import { Building2Icon, CheckIcon } from "lucide-react"

import { CompanyChangeDialog } from "@/components/company/partners/CompanyChangeDialog"
import { cn } from "@/lib/utils"

import type { Company } from "@boundless/bl-api-client/partners/models"

interface Props {
  company: Company
  isSelected: boolean
}

export function CompanyMiniCard({ company, isSelected }: Props) {
  return (
    <CompanyChangeDialog company={company}>
      <div
        className={cn(
          "bg-background relative flex h-32 w-32 flex-col items-center justify-between rounded-lg border p-3",
          isSelected ? "border-primary" : "border-transparent",
        )}
      >
        {isSelected && (
          <div className="bg-primary absolute top-2 right-2 flex h-4 w-4 items-center justify-center rounded-full border border-white text-xs text-white">
            <CheckIcon className="h-2 w-2" />
          </div>
        )}

        <div className="mt-4 flex h-12 w-12 items-center justify-center rounded-full bg-white">
          <Building2Icon />
        </div>

        <p className="text-center text-xs">{company.legalName}</p>
      </div>
    </CompanyChangeDialog>
  )
}
